import { PostErrorViewed } from '../domain/dtos'

export const makePostErrorViewedData = (data: PostErrorViewed) => ({
  userId: data.userId,
  productId: data.productId,
  errorType: data.errorType,
})
